export default ({ request }) => ({
  /**
     * 获取工作地点列表
     * @param data
     * @returns {*}
     * @constructor
     */
   GET_WORKCITY_LIST() {
    // 接口请求
    return request({
      url: `/position/workcity/list`,
      method: 'GET'
    })
  },

  /**
  * 获取职位列表
  * @param data
  * @returns {*}
  * @constructor
  */
  GET_POSITION_LIST(params = {}) {
    // 接口请求
    return request({
      url: '/position/list',
      method: 'GET',
      params
    })
  },

  
  /**
     * 根据主键获取职位明细
     * @param data
     * @returns {*}
     * @constructor
     */
   GET_POSITION_DETAIL(id, params) {
    // 接口请求
    return request({
      url: `/position/${id}`,
      method: 'GET',
      params
    })
  },

  /**
  * 投递职位
  * @param data
  * @returns {*}
  * @constructor
  */
   POSITION_DELIVERY(data = {}) {
    // 接口请求
    return request({
      url: '/position/delivery',
      method: 'POST',
      data
    })
  },

  
  /**
  * 收藏职位
  * @param data
  * @returns {*}
  * @constructor
  */
   POSITION_COLLECT(data = {}) {
    // 接口请求
    return request({
      url: '/position/collection',
      method: 'POST',
      data
    })
  },

  /**
  * 取消收藏
  * @param data
  * @returns {*}
  * @constructor
  */
   POSITION_COLLECT_DELETE(data = {}) {
    // 接口请求
    return request({
      url: '/position/collection/cannel',
      method: 'POST',
      data
    })
  },
})

